import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";

export default function Scorecard() {
  const { t } = useLang();
  const { user } = useAuth();
  const [ins, setIns] = useState([]);
  useEffect(() => { api.get("/inspections", { params: { inspector_id: user.id } }).then((r) => setIns(r.data)); }, [user.id]);
  const total = ins.length;
  const defects = ins.reduce((a, i) => a + (i.defects || []).length, 0);
  const a = ins.filter((i) => i.grade === "A").length;
  const milestoneComplete = total === 0 ? 0 : Math.round(a / total * 100);
  const stats = [
    { k: "inspections_done", v: total },
    { k: "defects_caught", v: defects },
    { k: "a_grades", v: a },
    { k: "milestone_completion", v: `${milestoneComplete}%` },
  ];
  return (
    <div>
      <div className="eyebrow">{t("nav_my_scorecard")}</div>
      <h1 className="text-2xl font-bold mb-4" style={{ color: "var(--brand-navy)" }}>{t("scorecard")}</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {stats.map((s) => (
          <div key={s.k} data-testid={`stat-${s.k}`} className="hag-surface p-4">
            <div className="text-xs uppercase tracking-widest text-[#7C8E9E]">{t(s.k)}</div>
            <div className="text-3xl font-black mt-2" style={{ color: "var(--brand-navy)" }}>{s.v}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
